import { Bitrix24Consumer } from 'contexts/legacy/Bitrix24Context';
import { LanguageContext } from 'contexts/legacy/LanguageContext';
import languages from 'languages/legacy';
import moment from 'moment';
import React from 'react';

class LanguageProvider extends React.Component {
	constructor(props) {
		super(props);
		const supportedLanguages = ['br', 'en', 'la'];
		let lang = window.BX24 ? window.BX24.getLang() : 'en';
		lang = supportedLanguages.includes(lang) ? lang : 'en';

		this.state = {
			lang,
			language: languages[lang] ?? languages.en,
		};
	}

	async componentDidMount() {
		moment.locale('en');
		this.changeLanguage();
	}

	changeLanguage = () => {
		window.BX24.init(async () => {
			let language = null;

			const supportedLanguages = ['br', 'en', 'la'];
			let lang = window.BX24 ? window.BX24.getLang() : 'en';
			lang = supportedLanguages.includes(lang) ? lang : 'en';

			try {
				language = languages[lang];
				moment.locale(lang);
			} catch (err) {
				language = languages.en;
			}

			this.setState({ language });
		});
	};

	render() {
		return (
			<LanguageContext.Provider value={this.state}>{this.props.children}</LanguageContext.Provider>
		);
	}
}

export default Bitrix24Consumer(LanguageProvider);
